/**
 * "Meus dados", aberto pelo menu da conta — spec 0087.
 *
 * Era um overlay feito à mão sobre a página de Perfil da barra lateral, que
 * também guardava a escolha entre as duas navegações. A escolha acabou com a
 * lateral; os dados ficam, na `Janela` da biblioteca (Esc, foco preso, volta
 * ao botão de origem).
 */
import { getUser } from '../../services/auth';
import { Campo, Janela } from '../common/interface';

interface Props {
  aberta: boolean;
  onFechar: () => void;
}

export function MeusDados({ aberta, onFechar }: Props) {
  const usuario = getUser();
  return (
    <Janela
      aberta={aberta}
      titulo="Meus dados"
      onFechar={onFechar}
      apoio="Para mudar estes dados, peça a quem administra os cadastros."
      acoes={<button type="button" className="fc-btn fc-btn-secundario" onClick={onFechar}>Fechar</button>}
    >
      <div className="casca-meus-dados">
        <Campo rotulo="Nome" valor={usuario?.nomeUsuario} />
        <Campo rotulo="Usuário" valor={usuario?.usuario} />
        <Campo rotulo="Cargo" valor={usuario?.domCargo} />
      </div>
    </Janela>
  );
}
